<template>
    <a-popover
        placement="bottomLeft"
        trigger="click"
        :overlayClassName="`${popoverClass} modern-custom-popover`"
        v-model="popoverVisible"
    >
        <template slot="content">
            <div class="modern-custom-dropdown">
                <slot name="content"></slot>
                <div v-if="showFormFooter" class="popover-actions">
                    <button class="action-btn clear-btn" @click="onClear">Temizle</button>
                    <button class="action-btn apply-btn" @click="onApply">Uygula</button>
                </div>
            </div>
        </template>

        <div class="modern-custom-trigger" :class="triggerClass">
            <slot name="trigger">
                <div class="select-button" :class="buttonClass">
                    <i v-if="showIcon && icon" class="material-icons button-icon">{{ icon }}</i>
                    <span class="button-text">{{ label }}</span>
                    <i v-if="removable" class="material-icons chip-remove-inline" @click.stop="onRemoveClick">close</i>
                    <i v-if="clearable && !removable" class="material-icons chip-clear-inline" @click.stop="onClearClick">delete_forever</i>
                    <i v-if="showDropdownArrow" class="material-icons dropdown-arrow">keyboard_arrow_down</i>
                </div>
            </slot>
        </div>
    </a-popover>
</template>

<script>
export default {
    name: "CustomPopover",
    props: {
        triggerClass: {
            type: String,
            default: "",
        },
        buttonClass: {
            type: String,
            default: "",
        },
        popoverClass: {
            type: String,
            default: "modern-custom-popover",
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        showDropdownArrow: {
            type: Boolean,
            default: true,
        },
        icon: {
            type: String,
            default: "label",
        },
        label: {
            type: String,
            default: "Seçin",
        },
        showFormFooter: {
            type: Boolean,
            default: false,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            popoverVisible: false,
        };
    },
    watch: {
        popoverVisible: {
            handler(val) {
                this.$emit("popover-change", val);
            },
        },
    },
    methods: {
        onClear() {
            this.$emit("clear");
            this.popoverVisible = false;
        },
        onApply() {
            this.$emit("apply");
            this.popoverVisible = false;
        },
        openPopover() {
            this.popoverVisible = true;
        },
        closePopover() {
            this.popoverVisible = false;
        },
        onRemoveClick() {
            this.$emit("remove-click");
        },
        onClearClick() {
            this.$emit("clear-click");
        },
    },
};
</script>

<style scoped lang="scss">
.modern-custom-trigger {
    display: inline-flex;
}

.select-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    transition: all 0.15s ease;

    &:hover {
        border-color: #22272d;
        background: #f8f9fa;
    }
}

.button-icon {
    font-size: 18px;
    color: #6b7785;
}

.button-text {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: #22272d;
    text-align: left;
}

.chip-remove-inline,
.chip-clear-inline {
    font-size: 16px;
    color: #9ca3af;
    cursor: pointer;
    padding: 2px;
    border-radius: 50%;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    line-height: 1;
    margin-left: 4px;

    &:hover {
        color: #dc3545;
        background: rgba(220, 53, 69, 0.1);
        transform: scale(1.15);
    }
}

.dropdown-arrow {
    font-size: 18px;
    color: #6b7785;
    transition: transform 0.2s ease;
}
</style>

<style lang="scss">
/* Global popover overrides rendered under body */
.modern-custom-popover {
    margin-top: -8px;

    .ant-popover-arrow {
        display: none;
    }

    .ant-popover-inner-content {
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        overflow: hidden;
        padding: 0;
    }

    .modern-custom-dropdown {
        min-width: 300px;
        background: #fff;
    }

    .popover-actions {
        display: flex;
        gap: 8px;
        padding: 12px;
        border-top: 1px solid #e5e7eb;
        background: #f8f9fa;
    }

    .action-btn {
        flex: 1;
        padding: 8px 16px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.15s ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }

    .clear-btn {
        background: #fff;
        color: #6b7280;

        &:hover {
            background: #f3f4f6;
            border-color: #9ca3af;
        }
    }

    .apply-btn {
        background: #22272d;
        color: #fff;
        border-color: #22272d;

        &:hover {
            background: #1f2937;
            border-color: #1f2937;
        }
    }
}

// Trigger hover state for dropdown arrow rotation
.modern-custom-popover.ant-popover-open .modern-custom-trigger .dropdown-arrow {
    transform: rotate(180deg);
}

// Oval chip style for GridContactListToolbar
.modern-custom-trigger .chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 5px 20px;
    border: 1px solid #c7d0d7;
    border-radius: 999px;
    background: #fff;
    color: #22272d;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;

    &:hover {
        background: #f0f0f0;
    }

    strong {
        font-weight: 700;
    }

    .material-icons {
        font-size: 18px;
        line-height: 1;
        color: #22272d;
    }
}
</style>
